<div class="welcome-page">
  <div class="welcome-container">
    <div class="welcome-content">
      <h1 class="welcome-ai">Welcome to Audience AI.</h1>
      <div class="text-style-3">
        Ask questions about your data or have AI help you build precise audience
        definitions using natural language.
      </div>
    </div>
    <div>
      <div class="ai-message">
        <ng-container *ngTemplateOutlet="AssistantIcon"></ng-container>
        <div *ngIf="isQueryRunning">
          <ng-container *ngTemplateOutlet="typingMessage"></ng-container>
        </div>
        <div *ngIf="!isQueryRunning">
          <div *ngIf="!hasResponseError" class="text-style-3">
            {{ chatContent }}
          </div>
          <div *ngIf="hasResponseError" class="text-style-3">
            <ng-container
              *ngTemplateOutlet="
                errorMessage;
                context: { $implicit: chatContent }
              "
            ></ng-container>
          </div>
        </div>
      </div>
      <ng-container
        *ngTemplateOutlet="chatInput; context: { $implicit: inputContext }"
      ></ng-container>
    </div>
    <div class="welcome-block">
      <div class="text-style-muted-1">Use one of our AI agents to...</div>
      <div class="card-block">
        <ng-container *ngFor="let card of welcomeCards">
          <coreui-card class="welcome-card">
            <div class="text-style-2">{{ card.title }}</div>
            <div class="text-style-muted-1">{{ card.description }}</div>
          </coreui-card>
        </ng-container>
      </div>
    </div>
  </div>
</div>
